// ##### Komarov 2025-07-24
import React, { useEffect } from 'react';
// ##### 24-08-01 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### 25-04-23 Komarov
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-04-23 Komarov
import { getLoadedPage } from '../../../../Redux/actions';
// ##### Komarov 2025-08-21
import { usePerformanceMeasure } from '../../../../hooks/usePerformanceMeasure';

// ##### Komarov 2025-07-14
// import '../../PageComponents/ResponsiveHeader/header.css'
// import './TopToursCSS.css'

// ##### Komarov 2025-07-13
const UnderSliderText = ({ sidePageID = 209 }) => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  // ##### Komarov 2025-08-27
  // Use the performance measurement hook
  usePerformanceMeasure('UnderSliderText', {
    logToConsole: true,
    componentDevMode,
    onMeasure: (result) => {
      // You can add additional analytics or logging here
      console.log(`📊 Performance data for UnderSliderText (${result.environment}):`, result);

      // Example: Send to analytics
      // analytics.track('component_performance', {
      //   ...result,
      //   page: typeof window !== 'undefined' ? window.location.pathname : 'server'
      // });
    }
  });
  // ##### 25-04-23 Komarov
  const loadedpages = useSelector(state => state.pages.loadedpages);
  const language = useSelector(state => state.language);
  const dispatch = useDispatch();
  // ##### Komarov 2025-07-28
  const purePage = loadedpages[sidePageID]?.[language];
  // ##### Komarov 2025-07-24: TODO: Здесь почему-то использование Media приводило к появлению второго пустого <div> на странице. Нужно бы разобраться, потому что мы уйдём от deviceType и перейдём на Media для отображения разметки (потому что Media даёт возможность настраивать отображение страницы под ширину экрана, а deviceType это просто привязка к типу устройства, которая должна использоваться только для типа картинок, которые мы получаем из Смарта).
  const deviceType = useSelector(state => state.deviceType);

  // ##### Komarov 2025-07-28
  useEffect(() => {
    if (!purePage) {
      dispatch(
        getLoadedPage({
          spid: sidePageID,
          lang: language,
          deviceType,
        })
      );
    }
    // ##### 23-04-12 Komarov
  }, [sidePageID, language, deviceType]);

  return (
    <div
      className="frontPageArticle"
      style={{ order: '5' }}
      data-component="UnderSliderTextSsr"
    >
      { /* ##### Komarov 2025-07-28 */}
      {purePage?.length > 0
        ? purePage.map(item => {
          if (item.content_name === 'Body')
            return (
              <div
                style={{
                  order: '2',
                  // ##### 24-03-21 Komarov
                  width: (deviceType !== 'desktop' && '95%') || '70%',
                }}
                key={() => uniqueId()}
              >
                {parse(item.text)}
              </div>
            );
        })
        : null}
    </div>
  );
};

export default UnderSliderText;
